import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { Link } from 'react-router-dom';
import { KC_COLORS } from '../theme';
import { KcIcon } from './KcIcon';

export function CategoryPageHeader({ category }) {
  return (
    <div id="kc-category-overview" className="kc-category-header pt-28 md:pt-32 pb-2 text-left scroll-mt-28">
      <nav aria-label="Breadcrumb" className="kc-category-breadcrumb mb-6 md:mb-8 text-left">
        <ol
          className="flex flex-wrap items-center justify-start gap-x-2 gap-y-1 kc-type-body font-semibold"
          style={{ color: KC_COLORS.navy700 }}
        >
          {category.breadcrumbs.map((crumb, index) => {
            const isLast = index === category.breadcrumbs.length - 1;
            return (
              <li key={`${crumb.label}-${index}`} className="inline-flex items-center gap-2">
                {index > 0 ? (
                  <span className="font-medium" style={{ color: KC_COLORS.gray600 }}>
                    &gt;
                  </span>
                ) : null}
                {crumb.path && !isLast ? (
                  <Link
                    to={crumb.path}
                    className="font-semibold transition-opacity hover:opacity-80"
                    style={{ color: KC_COLORS.navy700 }}
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span
                    className="font-semibold"
                    style={{ color: isLast ? KC_COLORS.gray600 : KC_COLORS.navy700 }}
                  >
                    {crumb.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>

      <div className="flex items-center justify-start gap-4 md:gap-5 text-left">
        <span
          className="inline-flex shrink-0 items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-2xl"
          style={{ backgroundColor: KC_COLORS.tealLight, color: KC_COLORS.teal }}
        >
          <KcIcon
            name={category.icon}
            fontSize="medium"
            sx={{ fontSize: { xs: 30, md: 34 } }}
          />
        </span>
        <h1 className="kc-category-title kc-type-h1 min-w-0 text-left">{category.title}</h1>
      </div>

      <p className="kc-category-desc kc-type-body mt-4 md:mt-5 max-w-3xl text-left">
        {category.description}
      </p>

      <div className="kc-category-meta mt-5 md:mt-6 flex flex-wrap items-center justify-start gap-x-6 gap-y-3">
        <span
          className="inline-flex items-center gap-2 kc-type-body font-medium"
          style={{ color: KC_COLORS.primaryNavy }}
        >
          <MenuBookOutlinedIcon sx={{ fontSize: 20, color: KC_COLORS.teal }} />
          {category.articleCountLabel}
        </span>
        <span
          className="inline-flex items-center gap-2 kc-type-body font-medium"
          style={{ color: KC_COLORS.primaryNavy }}
        >
          <AccessTimeOutlinedIcon sx={{ fontSize: 20, color: KC_COLORS.teal }} />
          {category.avgReadTimeLabel}
        </span>
      </div>
    </div>
  );
}
